import { hasPermissionToRead } from "common/functions/roles";
import type { Context } from "common/types/context";
import { Filter } from "common/types/filters";
import type { Role } from "common/types/roles";
import { VerticalField } from "common/ui/field";
import { Hint } from "common/widgets/hint";
import { LoadingIcon } from "common/widgets/loading-icon";
import { Required } from "common/widgets/required";
import { SitesSelectorWithChicklets } from "common/widgets/site-selector/with-chicklets";
import { RestrictToRoles } from "x/account-settings/roles/restrict-to-roles";

interface PropTypes {
  context: Context;
  allRoles: Role[];
  onSitesChange: (sites: string[]) => void;
  onRolesChange: (roleIds: number[]) => void;
  value: Filter;
  isLoading?: boolean;
}

export const FilterConfigurations = ({
  context,
  allRoles,
  value,
  onSitesChange,
  onRolesChange,
  isLoading,
}: PropTypes) => {
  const { userTypes, role } = context;
  const { sites = [], roleIds = [] } = value;

  if (isLoading) return <LoadingIcon />;

  const canAccessRoles = hasPermissionToRead(userTypes, role, "Roles");

  return (
    <>
      <VerticalField
        label={_("Select Site")}
        input={
          <Required value={sites.length ? sites : undefined}>
            <SitesSelectorWithChicklets
              context={context}
              placeholder={_("Select")}
              value={sites}
              onChange={onSitesChange}
            />
          </Required>
        }
      />
      {canAccessRoles ? (
        <RestrictToRoles
          label={_("Restrict view to specific roles?")}
          roles={allRoles}
          value={roleIds}
          onChange={onRolesChange}
        />
      ) : undefined}
      <Hint
        message={_(
          "Removing a site or role will also remove any related defaults.",
        )}
      />
    </>
  );
};
